/**
 * The words of the workspace's teams (identity's `/teams`, migration 0051): the screens — the list
 * `identity.teams`, the record `identity.team` and its members card `identity.team_members`, approved
 * by the owner on 2026-10-06 — what the change record names when a team or its members change, and
 * identity's refusals (`identity.refusal.team.*`, teams.service.ts). Kept beside the catalogue and
 * spread into it, so a parallel change to the catalogue does not collide with these.
 */
export const TEAMS_EN = {
    'nav.identity.teams': 'Teams',
    'screen.identity.teams.title': 'Teams',
    'screen.identity.teams.lede': 'Teams are groups of members that work is assigned to.',
    'screen.identity.teams.empty': 'No teams yet; a team is a group of members that work is assigned to.',
    'screen.identity.teams.column.name': 'Team',
    'screen.identity.teams.column.lead_name': 'Lead',
    'screen.identity.teams.column.member_count': 'Members',
    'screen.identity.teams.column.status': 'Status',
    'screen.identity.teams.action.create': 'New team',
    'screen.identity.teams.action.create.field.name': 'Name',
    'screen.identity.teams.action.create.field.lead_user_id': 'Lead',
    'screen.identity.teams.action.create.field.lead_user_id.help': 'Optional. Who the team’s work goes to first; a team grants no permission.',
    'screen.identity.teams.action.members': 'Members',
    'screen.identity.teams.action.members.field.user_ids': 'Who is in this team',
    'screen.identity.teams.action.members.field.user_ids.help': 'Tick to add a member, untick to remove one.',
    'screen.identity.teams.action.edit': 'Edit',
    'screen.identity.teams.action.archive': 'Archive',
    'screen.identity.team.title': 'Team',
    'screen.identity.team.subtitle.lead': 'Lead: {value}',
    'screen.identity.team.tab.members': 'Members',
    'screen.identity.team_members.title': 'Members',
    'screen.identity.team_members.column.name': 'Member',
    'screen.identity.team_members.column.role': 'In the team',
    'screen.identity.team_members.empty': 'Nobody is in this team yet.',
    'value.role.lead': 'Lead',
    'value.role.member': 'Member',
    'change.field.team.name': 'Team name',
    'change.field.team.lead_user_id': 'Team lead',
    'change.field.team.status': 'Status',
    'change.field.team.user_id': 'Member',
    'identity.refusal.team.name': 'Give the team a name.',
    'identity.refusal.team.name_length': 'A team’s name is at most 120 characters.',
    'identity.refusal.team.taken': 'An active team already has this name.',
    'identity.refusal.team.user': 'Choose the person from the workspace’s members.',
    'identity.refusal.team.user_ids': 'Send the whole list of the team’s members.',
    'identity.refusal.team.too_many': 'A team holds at most 500 members.',
    'identity.refusal.team.not_member': 'Only members of this workspace can be in a team or lead it.',
    'identity.refusal.team.version': 'Reload the team and try again.',
    'identity.refusal.team.stale': 'Someone else changed this team meanwhile. Reload it and try again.',
    'identity.refusal.team.status': 'A team is active or archived.',
    'identity.refusal.team.archived': 'An archived team keeps the members it had. Bring it back first.',
    'identity.refusal.team.missing': 'This team does not exist in this workspace.',
};
export const TEAMS_AR = {
    'nav.identity.teams': 'الفرق',
    'screen.identity.teams.title': 'الفرق',
    'screen.identity.teams.lede': 'الفرق مجموعات من المستخدمين يُسند إليها العمل',
    'screen.identity.teams.empty': 'لا فرق بعد؛ الفريق مجموعة من المستخدمين يُسند إليها العمل.',
    'screen.identity.teams.column.name': 'الفريق',
    'screen.identity.teams.column.lead_name': 'القائد',
    'screen.identity.teams.column.member_count': 'الأعضاء',
    'screen.identity.teams.column.status': 'الحالة',
    'screen.identity.teams.action.create': 'فريق جديد',
    'screen.identity.teams.action.create.field.name': 'الاسم',
    'screen.identity.teams.action.create.field.lead_user_id': 'القائد',
    'screen.identity.teams.action.create.field.lead_user_id.help': 'اختياري. من يصل إليه عمل الفريق أولاً؛ الفريق لا يمنح أي صلاحية.',
    'screen.identity.teams.action.members': 'الأعضاء',
    'screen.identity.teams.action.members.field.user_ids': 'من في هذا الفريق',
    'screen.identity.teams.action.members.field.user_ids.help': 'حدّد عضواً لتضيفه، وألغِ تحديده لتزيله.',
    'screen.identity.teams.action.edit': 'عدّل',
    'screen.identity.teams.action.archive': 'أرشف',
    'screen.identity.team.title': 'الفريق',
    'screen.identity.team.subtitle.lead': 'القائد: {value}',
    'screen.identity.team.tab.members': 'الأعضاء',
    'screen.identity.team_members.title': 'الأعضاء',
    'screen.identity.team_members.column.name': 'العضو',
    'screen.identity.team_members.column.role': 'في الفريق',
    'screen.identity.team_members.empty': 'لا أحد في هذا الفريق بعد.',
    'value.role.lead': 'القائد',
    'value.role.member': 'عضو',
    'change.field.team.name': 'اسم الفريق',
    'change.field.team.lead_user_id': 'قائد الفريق',
    'change.field.team.status': 'الحالة',
    'change.field.team.user_id': 'العضو',
    'identity.refusal.team.name': 'اكتب اسمًا للفريق.',
    'identity.refusal.team.name_length': 'اسم الفريق 120 حرفًا على الأكثر.',
    'identity.refusal.team.taken': 'يوجد فريق نشط بهذا الاسم.',
    'identity.refusal.team.user': 'اختر الشخص من أعضاء مساحة العمل.',
    'identity.refusal.team.user_ids': 'أرسل قائمة أعضاء الفريق كاملة.',
    'identity.refusal.team.too_many': 'يضم الفريق 500 عضو على الأكثر.',
    'identity.refusal.team.not_member': 'لا يكون في الفريق أو يقوده إلا أعضاء مساحة العمل هذه.',
    'identity.refusal.team.version': 'أعد تحميل الفريق وحاول مرة أخرى.',
    'identity.refusal.team.stale': 'غيّر شخص آخر هذا الفريق في الأثناء. أعد تحميله وحاول مرة أخرى.',
    'identity.refusal.team.status': 'الفريق إما نشط أو مؤرشف.',
    'identity.refusal.team.archived': 'يحتفظ الفريق المؤرشف بأعضائه. أعده إلى النشاط أولًا.',
    'identity.refusal.team.missing': 'لا يوجد هذا الفريق في مساحة العمل هذه.',
};
//# sourceMappingURL=i18n-teams.js.map